import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  isBillingAdmin,
  isSubscriptionLocked,
  PAYMENTS_PATH,
} from "../../utils/subscriptionAccess";

const SubscriptionPaywallBanner = () => {
  const user = useSelector((state) => state?.user);
  const location = useLocation();
  const billingAdmin = isBillingAdmin(user);

  if (
    !isSubscriptionLocked(user) ||
    location.pathname.startsWith(PAYMENTS_PATH)
  ) {
    return null;
  }

  return (
    <div
      className="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
      role="status"
    >
      <span>
        {billingAdmin
          ? "Your trial or subscription has expired. Subscribe to unlock dashboards, campaigns, integrations, and reports. You can still update profile, security, and billing settings."
          : "Your organization's trial or subscription has expired. Please contact your administrator to renew. You can still update your profile and security settings."}
      </span>
      {billingAdmin ? (
        <Link to={PAYMENTS_PATH} className="btn btn-sm btn-primary">
          View plans
        </Link>
      ) : null}
    </div>
  );
};

export default SubscriptionPaywallBanner;
